import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import appConfig from '../app.config.json';

/**
 * Custom hook to manage navigation loading state with minimum display time
 * Ensures loading indicator is visible for at least the configured duration during route changes
 * Default: 300ms (configurable via app.config.json)
 */
export const useNavigationLoading = (
  minimumDisplayTime = appConfig.navigation_loading_minimum_display_time_ms,
): boolean => {
  const location = useLocation();
  const [isNavigating, setIsNavigating] = useState(false);

  useEffect(() => {
    setIsNavigating(true);
    const timer = setTimeout(() => setIsNavigating(false), minimumDisplayTime);
    return () => clearTimeout(timer);
  }, [location.pathname, minimumDisplayTime]);

  return isNavigating;
};

export default useNavigationLoading;
